module.exports = __webpack_public_path__ + "img/internet-box-00-large.9d4f4769.png";